import React from "react";
import { observer } from "mobx-react";
import { SatelliteHeartbeatViewStore } from "../../store";
import { SatelliteHeartbeatViewForm } from "./SatelliteHeartbeatViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type SatelliteHeartbeatViewProps = {
  satelliteHeartbeatViewStore: SatelliteHeartbeatViewStore;
};

export const SatelliteHeartbeatView: React.FC<SatelliteHeartbeatViewProps> =
  observer(({ satelliteHeartbeatViewStore }) => {
    return (
      <div>
        <SatelliteHeartbeatViewForm
          receivedAt={satelliteHeartbeatViewStore.receivedAtValue}
          publicIp={satelliteHeartbeatViewStore.publicIpValue}
          latency={satelliteHeartbeatViewStore.latencyValue}
          cpuUsage={satelliteHeartbeatViewStore.cpuUsageValue}
          memoryUsage={satelliteHeartbeatViewStore.memoryUsageValue}
          diskUsage={satelliteHeartbeatViewStore.diskUsageValue}
          activeTasksCount={satelliteHeartbeatViewStore.activeTasksCountValue}
          proxyStats={satelliteHeartbeatViewStore.proxyStatsValue}
          systemInfo={satelliteHeartbeatViewStore.systemInfoValue}
          satelliteMachineValue={
            satelliteHeartbeatViewStore.satelliteMachineValue
          }
          onPrint={(handlePrint: () => void) =>
            satelliteHeartbeatViewStore.printSatelliteHeartbeat(handlePrint)
          }
          onCancel={() =>
            satelliteHeartbeatViewStore.cancelSatelliteHeartbeat()
          }
          onEdit={
            satelliteHeartbeatViewStore.isEditEnabled
              ? () => satelliteHeartbeatViewStore.editSatelliteHeartbeat()
              : undefined
          }
        />
        <ErrorDialog
          open={satelliteHeartbeatViewStore.errorDialogOpened}
          title={satelliteHeartbeatViewStore.errorTitle}
          description={satelliteHeartbeatViewStore.errorDescription}
          onClose={() => satelliteHeartbeatViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
